import * as React from 'react';
import { useInView } from './useInView';
export default function useIframe(url) {
    const [refIframe, inView] = useInView({});
    const [status, setStatus] = React.useState('initial');
    React.useEffect(() => {
        if (!refIframe.current) {
            return;
        }
        if (!inView || !url) {
            return;
        }
        // Set iframe when in view.
        setStatus('loading');
        refIframe.current.src = url;
        refIframe.current.addEventListener('load', () => {
            setStatus('complete');
        });
    }, [inView, url]);
    return [refIframe, status];
}
